'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dPage$0024 from "./presto.-Dashboard-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002499 from "./presto.-Presto-Router$$anon$99.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$98() {
  this.br6 = null;
  this.bqY = null;
  this.bqZ = false;
  this.br7 = null;
  this.br8 = false;
  this.brb = null;
  this.br4 = null;
  this.br5 = false;
  this.br0 = null;
  this.br1 = false;
  this.br2 = null;
  this.br3 = false;
  this.br9 = false;
  this.bra = false;
  this.br6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.brb = "DashboardPage";
}
export { $c_Lpresto_PrestoRouter$$anon$98 as $c_Lpresto_PrestoRouter$$anon$98 };
$p = $c_Lpresto_PrestoRouter$$anon$98.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$98;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$98() {
}
export { $h_Lpresto_PrestoRouter$$anon$98 as $h_Lpresto_PrestoRouter$$anon$98 };
$h_Lpresto_PrestoRouter$$anon$98.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.br6;
});
$p.M = (function() {
  if ((!this.bqZ)) {
    this.bqY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bqZ = true;
  }
  return this.bqY;
});
$p.O = (function() {
  if ((!this.br8)) {
    this.br7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.br8 = true;
  }
  return this.br7;
});
$p.D = (function() {
  return this.brb;
});
$p.t = (function() {
  if ((!this.br5)) {
    this.br4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.br5 = true;
  }
  return this.br4;
});
$p.N = (function() {
  if ((!this.br1)) {
    this.br0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.br1 = true;
  }
  return this.br0;
});
$p.Q = (function() {
  if ((!this.br3)) {
    this.br2 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002499.$c_Lpresto_PrestoRouter$$anon$99();
    this.br3 = true;
  }
  return this.br2;
});
$p.v = (function() {
  if ((!this.bra)) {
    this.br9 = false;
    this.bra = true;
  }
  return this.br9;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee604) => ((p) => \u03b4scrutinee604))($j_presto$002e$002dDashboard$002dPage$0024.$m_Lpresto_DashboardPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$98 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$98, "presto.PrestoRouter$$anon$98", ({
  Pg: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$98 as $d_Lpresto_PrestoRouter$$anon$98 };
//# sourceMappingURL=presto.-Presto-Router$$anon$98.js.map
